export default __webpack_public_path__ + "static/dashboard-side-tab-854dd60d284deeb27034e69cb1461b3c.png";